// import sa from 'sa-sdk-javascript'
// import {getUserAgentInit,invokeApi} from './GLOBAL2'
// import {loginCookieName,getGlobalConstant} from './public_link'
// import {getWebDomain,GetQueryString,getCookie,setCookie} from './common'
//
// let globalConst = getGlobalConstant();
const sa = {
    track:()=>{
        console.log('删除的神策')
    }
}
// sa.init({
//     server_url:'globalConst.sensors_server_url',
//     name:'sa',
//     heatmap_url:'',
//     web_url:'globalConst.sensors_web_url',
//     heatmap: {
//         //是否开启点击图，默认 default 表示开启，可以设置 'not_collect' 表示关闭
//         clickmap:'default',
//         //是否开启触达注意力图，默认 default 表示开启，可以设置 'not_collect' 表示关闭
//         scroll_notice_map:'default',
//         //设置成 true 后，我们会自动给 a 标签绑定一个 sa.trackLink() 方法（详见本页 3.3 ）。
//         //如果是单页面 a 标签不涉及页面跳转或者 a 标签的点击是下载功能，建议不要打开。默认 false 。
//         isTrackLink: false,
//         //设置多少毫秒后开始渲染点击图,因为刚打开页面时候页面有些元素还没加载
//         loadTimeout:  3000,
//         //返回真会采集当前页面的数据，返回假表示不采集当前页面,设置这个函数后，内容为空的话，是返回假的。不设置函数默认是采集所有页面
//         collect_url: function(){
//             return true;
//         },
//         //用户点击（a，button，input）这些元素时会触发这个函数，让你来判断是否要采集当前这个元素，返回真表示采集，返回假表示不采集。
//         //不设置这个函数，默认是采集 a button input 这些标签。
//         collect_element: function(element_target){
//             // 如果这个元素有属性sensors-disable=true时候，不采集
//             if(element_target.getAttribute('sensors-disable') === 'true'){
//                 return false;
//             }else{
//                 return true;
//             }
//         },
//         //考虑到用户隐私，这里可以设置input里的内容是否采集
//         //如果返回真，表示采集input内容，返回假表示不采集input内容,默认不采集
//         collect_input:function(element_target){
//             //例如如果元素的id是a，就采集这个元素里的内容
//             if(element_target.id === 'a'){
//                 return true;
//             }
//         },
//         //假如要在 $WebClick 事件增加自定义属性，可以通过（a，button，input）这三类标签的特征来判断是否要增加
//         custom_property:function( element_target ){
//             //比如您需要给有 data=test 属性的标签的点击事件增加自定义属性 name:'aa' ，则代码如下
//             if(element_target.getAttribute('data') === 'test'){
//                 return {
//                     name:'aa'
//                 }
//             }
//         },
//         // 设置触达图的有效停留时间，默认超过4秒以上算有效停留
//         scroll_delay_time: 4000,
//         // 关闭 $WebStay (Web 视区停留) 事件
//         scroll_notice_map:'not_collect',
//         // 关闭 $WebClick（Web 元素点击）事件
//         clickmap:'not_collect'
//     }
//
// });
// function analysisConfig(){
//     invokeApi('customer/getCustomerIds',{},'post',Math.random(),function (res) {
//         console.log(res);
//         sessionStorage.setItem('cookieUserId',1);
//         // setCookie('cusId',res.customerId);
//         sa.login(res.customerId);
//         sa.quick('autoTrack')
//     })
// }
// function getPlatfrom(){
//     return getUserAgentInit()
// }
// setTimeout(function () {
//     let cookieLoginN = getCookie(loginCookieName);
//     let cookieUserId = (getCookie('cusId')||'').indexOf('|')>-1?getCookie('cusId').split('|')[0]:getCookie('cusId')
//     let orderCount = (getCookie('cusId')||'').indexOf('|')>-1?parseInt(getCookie('cusId').split('|')[1]):0
//     sa.registerPage({orderNumberSensors:orderCount})
//     sa.register({
//         fromPlatform:getPlatfrom()
//     });
//     if(cookieUserId){
//         sa.login(cookieUserId);
//         sa.quick('autoTrack')
//     }else if(cookieLoginN){
//         analysisConfig();
//     }
//
//
//
//     var source = GetQueryString("lcjiance");
//     if (source == undefined || source == null){
//         source = "";
//     }
//     var pageView = GetQueryString("lcpageview");
//     if (pageView == undefined || source == null){
//         pageView = "";
//     }
//     var bindCode = GetQueryString("bindCode");
//
//     //新的事件
//     var lcwebParam = {};
//     if(pageView!=""){
//         lcwebParam['lcpageview'] = pageView;
//     }
//     if(source!=""){
//         lcwebParam['lcjiance'] = source;
//     }
//     if(!$.isEmptyObject(lcwebParam)){
//         sa.track('lcweb',lcwebParam);
//     }
//
//     if(pageView!="") {
//         var pro="({"+pageView.split('_')[0]+":'"+pageView+"'})";
//         if(pro!=null&&pro!=undefined)
//             sa.track('lcpageview', eval(pro));
//     }
//     if (source == 1) {//乐纯头条
//         sa.track('lcjiance', {dataFrom: '乐纯头条'});
//     } else if (source == '1_2') {   //乐纯食堂
//         sa.track('lcjiance', {dataFrom: '乐纯头条02'});
//     } else if (source == '1_3') {   //乐纯食堂
//         sa.track('lcjiance', {dataFrom: '乐纯头条03'});
//     } else if (source == '1_4') {   //乐纯食堂
//         sa.track('lcjiance', {dataFrom: '乐纯头条04'});
//     } else if (source == '1_5') {   //乐纯食堂
//         sa.track('lcjiance', {dataFrom: '乐纯头条05'});
//     } else if (source == 2) {   //乐纯食堂
//         sa.track('lcjiance', {dataFrom: '乐纯食堂'});
//     } else if (source == 3) {   //乐纯口碑
//         sa.track('lcjiance', {dataFrom: '乐纯口碑'});
//     } else if (source == 4) {   //乐纯plus
//         sa.track('lcjiance', {dataFrom: '乐纯plus'});
//     } else if (source == 5) {   //纯吃货
//         sa.track('lcjiance', {dataFrom: '纯吃货'});
//     } else if (source == 6) {
//         sa.track('lcjiance', {dataFrom: '乐纯主文2'});
//     } else if (source == 7) {
//         sa.track('lcjiance', {dataFrom: '优惠券到期提醒'});
//     } else if (source == 8) {
//         sa.track('lcjiance', {dataFrom: '乐纯12问'});
//     } else if (source == 9) {
//         sa.track('lcjiance', {dataFrom: '乐纯包月特惠'});
//     } else if (source == 21) {
//         sa.track('lcjiance', {dataFrom: '首页优惠券点击'});
//     } else if (source == 22) {
//         sa.track('lcjiance', {dataFrom: '首页余额点击'});
//     } else if (source == 23) {
//         sa.track('lcjiance', {dataFrom: '首页乐享活动点击'});
//     } else if (source == 24) {
//         sa.track('lcjiance', {dataFrom: '首页长期订购点击'});
//     } else if (source == "vip_active_a") {
//         sa.track('lcjiance', {dataFrom: '会员激活A'});
//     } else if (source == "vip_active_b") {
//         sa.track('lcjiance', {dataFrom: '会员激活B'});
//     } else if (source == "vip_active_c") {
//         sa.track('lcjiance', {dataFrom: '会员激活C'});
//     } else if (source == "vip_active_a1") {
//         sa.track('lcjiance', {dataFrom: '会员跳转A'});
//     } else if (source == "vip_active_b1") {
//         sa.track('lcjiance', {dataFrom: '会员跳转B'});
//     } else if (source == "vip_active_c1") {
//         sa.track('lcjiance', {dataFrom: '会员跳转C'});
//     } else if (source == "d") {
//         sa.track('lcjiance', {dataFrom: '会员两单'});
//     } else if (source == "e") {
//         sa.track('lcjiance', {dataFrom: '会员长期'});
//     } else if (source == "vip_active_f1") {
//         sa.track('lcjiance', {dataFrom: '跳转至会员中心'});
//     } else if (source == "vip_active_f2") {
//         sa.track('lcjiance', {dataFrom: '跳转至商城首页'});
//     } else if (source == "please1") {
//         sa.track('lcjiance', {dataFrom: '请酸奶微信菜单点击'});
//     } else if (source == "please2") {
//         sa.track('lcjiance', {dataFrom: '请酸奶乐享活动点击'});
//     } else if (source == "please3") {
//         sa.track('lcjiance', {dataFrom: '请酸奶推文点击'});
//     } else if (source == "please4") {
//         sa.track('lcjiance', {dataFrom: '请酸奶首页banar点击'});
//     } else if (source == "scancodepay") {
//         sa.track('lcjiance', {dataFrom: '图片传播支付按钮点击'});
//     } else {
//         if (source != "")
//             sa.track('lcjiance', {dataFrom: source});
//     }
//
//     //公共点击埋点
//     let analysisItem = document.querySelectorAll('.analysis');
//    // if(isArray(analysisItem)){
//        analysisItem.forEach(function (item,index) {
//            item.addEventListener('click',function(){
//                console.log(this)
//                var pageView = GetQueryString("lcpageview");
//                var Analysis=item.getAttribute("data-analysis")
//                if (pageView == undefined) {
//                    pageView = "";
//                }
//                if(pageView == "" && (window.location.pathname == "/" || window.location.pathname == "/active/family/index.html")){
//                    pageView = "lcpageview";
//                }
//                if(pageView == "" && window.location.pathname == "/account/personal_info.html"){
//                    pageView = "lcpageview";
//                }
//                if (pageView != "") {
//                    var pro="({"+pageView+":'"+pageView+"_"+Analysis+"'})";
//                    sa.track('lcpageview', eval(pro));
//                }
//                //新的事件
//                var lcwebClickParam = {};
//                if(pageView!=""){
//                    lcwebClickParam['lcpageview'] = pageView;
//                }
//                if(source!=""){
//                    lcwebClickParam['lcjiance'] = source;
//                }
//                if(Analysis!=""){
//                    lcwebClickParam['lcclick'] = Analysis;
//                }
//                sa.track('lcweb',lcwebClickParam);
//                if(bindCode!=''||window.location.pathname.indexOf('/active/')>=0){
//                    sa.track('WechatActive',lcwebClickParam);
//                }
//            },false);
//        });
// },1000);
export{sa}



// WEBPACK FOOTER //
// ./src/resource/js/ANALYSIS2.js